import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router";

interface MenuItem {
  label: string;
  link?: string;
  children?: MenuItem[];
}

const MenuItems = ({ parentMenu }: { parentMenu: MenuItem[] }) => {
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const navigate = useNavigate();

  const isPathActive = (path: string) => location.pathname === path;

  const handleClick = (route: string) => {
    navigate(route);
  };

  const toggleDropdown = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <ul className="flex flex-col sm:space-x-2 md:flex-row md:space-x-2 lg:w-full lg:items-center lg:justify-evenly lg:space-x-6">
      {parentMenu.map((menu, index) => (
        <li key={index} className="group relative w-full md:w-auto">
          {menu.children ? (
            /* Button for items with sublinks */
            <button
              onClick={() => toggleDropdown(index)}
              className={`flex w-full items-center justify-between px-4 py-2 text-gray-800 hover:text-blue-600 md:cursor-default ${
                isPathActive(menu.link || "")
                  ? "font-semibold text-blue-600"
                  : ""
              }`}
            >
              <span>{menu.label}</span>
              <span className="ml-2 inline-block transform md:group-hover:rotate-180">
                {activeIndex === index ? "▲" : "▼"}
              </span>
            </button>
          ) : (
            /* Link for items without sublinks */
            <button
              onClick={() => handleClick(menu.link || "")}
              className={`flex w-full items-center justify-between px-4 py-2 text-gray-800 hover:text-blue-600 ${
                isPathActive(menu.link || "")
                  ? "font-semibold text-blue-600"
                  : ""
              }`}
            >
              {menu.label}
            </button>
          )}

          {/* Dropdown for Submenu */}
          {menu.children && (
            <ul
              className={`ml-2 flex flex-col pl-5 md:invisible md:absolute md:left-0 md:mt-2 md:w-48 md:overflow-hidden md:rounded-md md:bg-white md:pl-0 md:opacity-0 md:shadow-lg md:transition-all md:duration-300 md:group-hover:visible md:group-hover:opacity-100 ${
                activeIndex === index ? "block" : "hidden"
              } md:block`}
            >
              {menu.children.map((child, childIndex) => (
                <li key={childIndex} className="w-full">
                  <button
                    onClick={() => handleClick(child.link || "")}
                    className={`md: block bg-gray-100 px-4 py-2 text-gray-700 hover:bg-gray-200 hover:text-blue-600 ${
                      isPathActive(child.link || "")
                        ? "font-semibold text-blue-600"
                        : ""
                    }`}
                  >
                    {child.label}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  );
};

export default MenuItems;
